<ion-item lines="none">
  <ion-label *ngIf="!hideLabel">{{label}}</ion-label>
  <span class="result">{{total}}</span>
</ion-item>